import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import PropTypes from "prop-types";

import { Button } from "@transfr-inc/dashboard-components/forms";

import { BetaBadge } from "@components/custom/content";
import { AILayoutBackground } from "@src/layouts/ai";

import "./programs-entry-cards.scss";

export const ProgramsEntryCards = ({
  onBrowse,
  onGetRecommendations,
  className,
}) => {
  return (
    <div className={clsx("programs-entry-cards", className)}>
      <div className="programs-entry-card browse">
        <div className="programs-entry-card-title">
          <FontAwesomeIcon icon={["fa-solid", "layer-group"]} />
          <h3>Browse our library</h3>
        </div>
        <p>
          Pick a ready-made program from our library and make edits before you
          assign it.
        </p>
        <Button primary onClick={onBrowse} disabled={!onBrowse}>
          Browse Programs
        </Button>
      </div>
      <AILayoutBackground className="programs-entry-card recommendations">
        <BetaBadge />
        <div className="programs-entry-card-title">
          <FontAwesomeIcon icon={["fa-regular", "wand-magic-sparkles"]} />
          <h3>Get recommendations</h3>
        </div>
        <p>
          Let our AI curriculum assistant build a starting program from your
          standards, syllabus, or a short form.
        </p>
        <Button onClick={onGetRecommendations} disabled={!onGetRecommendations}>
          AI Curriculum Assistant
        </Button>
        <span className="programs-entry-card-note">
          Powered by Transfr Intelligence
        </span>
      </AILayoutBackground>
    </div>
  );
};

ProgramsEntryCards.propTypes = {
  onBrowse: PropTypes.func,
  onGetRecommendations: PropTypes.func,
  className: PropTypes.string,
};
